import { __awaiter } from '../_virtual/_tslib.js';
import { useState, useEffect } from 'react';
import { IP_DATA_KEY } from '../constants/misc.js';
import { getCurrentLocation } from '../methods/getCurrentLocation.js';
import { useCsDashboard } from './useCsDashboard.js';
import { searchUsingPlacesAPI } from '../_services/city-search.service.js';

function useGetCurrentLocation() {
    const { isCsDashboardUser } = useCsDashboard();
    const getAndSetCurrentLocation = (paramsOption) => __awaiter(this, void 0, void 0, function* () {
        if (isCsDashboardUser) {
            return;
        }
        const locDataRes = yield fetch(`https://api.ipdata.co?api-key=${IP_DATA_KEY}`);
        if (locDataRes.status === 200) {
            const locData = yield locDataRes.json();
            const { name, id, state, state_id, state_code } = (yield searchUsingPlacesAPI(locData.city, paramsOption))[0];
            const currLocObj = {
                status: "done",
                lat: locData.latitude,
                lng: locData.longitude,
                id,
                name,
                state,
                state_id,
                state_code
            };
            // setCurrentLocation?.(currLocObj);
            return currLocObj;
        }
        // if (!currentLocation) {
        //     const savedLoc = JSON.parse(window.localStorage.getItem("currentLocation") || "null") as Location;
        //     if (savedLoc) {
        //         setCurrentLocation?.({
        //             lat: savedLoc.lat,
        //             lng: savedLoc.lng,
        //             city: savedLoc.city,
        //             state: savedLoc.state
        //         });
        //     } else {
        // window.navigator.geolocation.getCurrentPosition(
        //     ({ coords }) => {
        //         setCurrentLocation?.({ lat: coords.latitude, lng: coords.longitude, status: "done" });
        //         // window.localStorage.setItem(
        //         //     "currentLocation",
        //         //     JSON.stringify({ lat: coords.latitude, lng: coords.longitude })
        //         // );
        //     },
        //     () => {
        //         setCurrentLocation?.({ status: "denied" });
        //         toast.error("Please enable location permission from settings and try again!", {
        //             position: "top-center",
        //             draggable: false,
        //             transition: Slide
        //         });
        //     }
        // );
        // }
        // }
    });
    return { getAndSetCurrentLocation };
}
function useGetCurrentLocationOnPageLoad({ enabled = true, locationSearchParams }) {
    const { isCsDashboardUser } = useCsDashboard();
    // const { setCurrentLocation } = useContext(AppContext);
    const [currLoc, setCurrLoc] = useState();
    // const { getAndSetCurrentLocation } = useGetCurrentLocation();
    useEffect(() => {
        // setCurrentLocation?.({ status: "loading" });
        if (!enabled || isCsDashboardUser) {
            return;
        }
        (() => __awaiter(this, void 0, void 0, function* () {
            const res = yield getCurrentLocation(false, locationSearchParams);
            setCurrLoc(res);
        }))();
        // if (navigator.permissions) {
        //     navigator.permissions.query({ name: "geolocation" }).then((status) => {
        //         if (status.state === "granted") {
        //             setCurrentLocation?.({ status: "loading" });
        //             getAndSetCurrentLocation();
        //         }
        //     });
        // } else {
        //     // for Safari
        //     setCurrentLocation?.({ status: "loading" });
        //     getAndSetCurrentLocation();
        // }
        // // window.navigator.geolocation. getAndSetCurrentLocation();
    }, [enabled, isCsDashboardUser]);
    return currLoc;
}

export { useGetCurrentLocation, useGetCurrentLocationOnPageLoad };
//# sourceMappingURL=useGetCurrentLocation.js.map
